export interface NavItem {
  href: string;
  label: string;
}

export const UNIT_LINKS: NavItem[] = [
  { href: '#/units/sales', label: 'Sales' },
  { href: '#/units/marketing', label: 'Marketing' },
  { href: '#/units/customer-service', label: 'Customer Service' },
  { href: '#/units/operations', label: 'Operations' },
  { href: '#/units/quality-control', label: 'Quality Control' },
  { href: '#/units/hr', label: 'HR' },
  { href: '#/units/it', label: 'IT' },
  { href: '#/units/finance', label: 'Finance' },
];

export const TOP_LINKS: NavItem[] = [
  { href: '#/', label: 'Command Center' },
  ...UNIT_LINKS,
  { href: '#/workers', label: 'Worker Status' },
];

export function renderNav(currentHash: string): string {
  return TOP_LINKS.map(
    (item) =>
      `<a href="${item.href}" class="${item.href === currentHash ? 'active' : ''}">${item.label}</a>`,
  ).join('');
}
